'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function StationEditController($scope, $filter, $state, AppConstants, PageHeading, StationComponent, CityComponent, Toast, Station) {
	'ngInject';

	var vm = this;
	vm.clearResults = clearResults;
	vm.selectItemFromAutoComplete = selectItemFromAutoComplete;
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.updateStation = updateStation;
	vm.station = {};
	vm.cityName = Station.city.translation.name;
	vm.getPaginationInfo = StationComponent.getPaginationInfo;
	vm.languages = AppConstants.languages;

	activate();

	function activate() {
		vm.station.city_id = Station.city.id;
		vm.station.translations = Station.translations;
		vm.languages.forEach(function (lang) {
			if (!_lodash2['default'].find(vm.station.translations, { 'lang': lang })) {
				vm.station.translations.push({ 'lang': lang, 'name': '' });
			}
		});

		var heading = $filter('translate')('HEADING.EDITING_STATION');
		var title = 'BTMS | ' + $filter('translate')('HEADING.EDITING_STATION');

		PageHeading.setPageHeading(heading, title);
	}

	/**
  * Clears the results from the autocomplete search.
  */
	function clearResults() {
		CityComponent.clearResultSearchCities();
	}

	/**
  *  When is chosen city from a autoComplete input.
  *  We setting vm.query(name of item) and station.city_id(id of item),
  *  station model will be sending for create new station.
  * @param city
  */
	function selectItemFromAutoComplete(city) {
		vm.station.city_id = city.id;
		vm.cityName = city.translation.name;
	}

	function updateStation(params) {
		var hasErrors = false;

		angular.forEach($scope.editStation.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		StationComponent.updateStation(Station.id, params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				Toast.success($filter('translate')('SUCCESS.UPDATE_STATION'));
				$state.go('app.private.stations.list', { 'page': vm.getPaginationInfo().page });
			}
		});
	}
}

exports['default'] = StationEditController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/stations/edit/edit.controller.js
 **/